import { useLayoutEffect, useEffect, useRef, useState, useContext } from 'react';
import { InputText } from 'primereact/inputtext';
import { MainContext } from '../../App';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { ScrollPanel } from 'primereact/scrollpanel';
import CharlyChatMessageList from './CharlyChatMessageList';
import { CharlyChatContext } from './CharlyChat';
import useGetChatMessagesOnSearch from '../../hooks/useGetChatMessagesOnSearch';
import usePostChatmessagesUserQuestion from '../../hooks/usePostChatmessagesUserQuestion';
import { toast } from 'react-toastify';
import usePostChat from '../../hooks/usePostChat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

function CharlyChatWindow() {
  const { chatId, setChatId, setLoadingChat, loadingChat, messages, setMessages, totalCount, setTotalCount, setChatSearchData, setMenuVisible, caoOption} = useContext(CharlyChatContext);
  const { userId, amountPerPage } = useContext(MainContext);

  const [messageSearchData, setMessageSearchData] = useState(null);
  const [input, setInput] = useState('');
  const [agentTyping, setAgentTyping] = useState(false);
  const [loadingOlder, setLoadingOlder] = useState(false);
  const inputRef = useRef(null);
  const scrollPanelRef = useRef(null);
  const isAppendingRef = useRef(true);

  const { chatMessages } = useGetChatMessagesOnSearch(messageSearchData);
  let [chatmessageUserQuestionTriggered, setChatmessageUserQuestionTriggered] = useState(false);
  let postChatmessagesUserQuestion = usePostChatmessagesUserQuestion(chatmessageUserQuestionTriggered, chatId, userId, input, caoOption)

  const postChat = usePostChat();

  useEffect(() => {
    if (chatId > 0) {
      setMessages([]);
      setLoadingChat(true);
      setMessageSearchData({
        ChatId: chatId,
        CurrentPage: 1,
        AmountPerPage: amountPerPage,
        ReloadData: new Date()
      });
    }
  }, [chatId, amountPerPage]);

  useEffect(() => {
    if (chatMessages && chatMessages['page-items']) {
      const sortedItems = [...chatMessages['page-items']].sort((a, b) => a.id - b.id);

      if(messageSearchData.CurrentPage === 1) {
        setMessages(sortedItems);
      } else {
        setMessages(prev => [...sortedItems, ...prev]);
      }
      
      setTotalCount(chatMessages['total-count']);
      setLoadingChat(false);
      setLoadingOlder(false);
    }
  }, [chatMessages]);

  useEffect(() => {
    if (!agentTyping && inputRef.current) {
      inputRef.current.focus();
    }
  }, [agentTyping]);

  useLayoutEffect(() => {
    if (isAppendingRef.current) {
      scrollToBottom();
    }
    else{
        scrollToLastUserMessage();
    }
  }, [messages]);

  function scrollToBottom() {
    if (scrollPanelRef.current) {
      const scrollElem = scrollPanelRef.current.getContent();
      scrollElem.scrollTop = scrollElem.scrollHeight;
    }
  }

  function scrollToLastUserMessage() {
  if (!scrollPanelRef.current) return;

  const content = scrollPanelRef.current.getContent();
  const bubbles = content.querySelectorAll('[data-message]');
  if (bubbles.length === 0) return;

  const lastUserBubble = bubbles[bubbles.length - 1];
  const top = lastUserBubble.offsetTop;
  content.scrollTop = top;
}



  async function handleSend() {
    if (!input.trim()) return;

    isAppendingRef.current = false;
    setAgentTyping(true);

    if (chatId === 'new'){
      try {
        const newChat = await postChat(userId);
        setChatId(newChat.id);
        setChatSearchData({
          UserId: userId,
          CurrentPage: 1,
          AmountPerPage: amountPerPage,
          ReloadData: new Date()
        });
      }
      catch(err) {
        toast.error("Er is iets misgegaan bij het aanmaken van de chat. Probeer het alstublieft opnieuw.")
        setAgentTyping(false);
        return;
      }
    }

    setChatmessageUserQuestionTriggered(true);
  }

  useEffect(() => {
    if(postChatmessagesUserQuestion) {
      if(postChatmessagesUserQuestion.status === 200) {
        setMessageSearchData({
          ChatId: chatId,
          CurrentPage: 1,
          AmountPerPage: amountPerPage,
          ReloadData: new Date()
        });

        setInput('');
      }
      else{
        toast.error("Oeps, er ging iets fout. Probeer het nog eens.");
      }
      setAgentTyping(false);
      setChatmessageUserQuestionTriggered(false);
    }
  }, [postChatmessagesUserQuestion])

  if (chatId <= 0) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        <p className="text-muted m-0">Selecteer een chat</p>
      </div>
    );
  }

  return (
    <>
      {loadingChat ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" />
        </div>
      ) : (
        <div className="d-flex flex-column position-relative" style={{ height: 'calc(100dvh - 115px)', overflow: 'hidden' }}>
          <div style={{ flex: 1, minHeight: 0 }}>
            <ScrollPanel ref={scrollPanelRef} style={{ width: '100%', height: '100%' }} className="px-2">
              {/* {messages.length >= totalCount && (
                <div className="text-center py-2 text-muted">
                  <small>No older messages available</small>
                </div>
              )} */}
              {loadingOlder && (
                <div className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                  <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="4" />
                  <small className="text-muted">Eerdere berichten worden geladen...</small>
                </div>
              )}
              {messages.length < totalCount && !loadingOlder && (
                <div
                  className="d-flex justify-content-center"
                  style={{ position: 'sticky', top: 0, zIndex: 10, background: '#fff' }}
                >
                  <Button
                    label="Meer weergeven"
                    icon="pi pi-chevron-up"
                    className="p-button-text p-button-sm"
                    onClick={() => {
                      setLoadingOlder(true);
                      const nextPage = Math.floor(messages.length / amountPerPage) + 1;
                      setMessageSearchData(prev => ({ ...prev, CurrentPage: nextPage }));
                    }}
                  />
                </div>
              )}
              <div className="px-3">
                <CharlyChatMessageList messages={messages} />
              </div>
            </ScrollPanel>
          </div>

          {agentTyping && (
            <div className="p-text-secondary p-text-center p-mt-2 p-text-sm agent-typing">
              Charly is aan het nadenken...
            </div>
          )}

          <div className="p-inputgroup mt-3 px-3 pb-3">
            <Button
                icon={<FontAwesomeIcon icon={faBars} />} 
                className="p-button" onClick={() => setMenuVisible(true)}
            />
            <InputText
              className="p-inputtext"
              placeholder="Type een bericht"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !agentTyping) handleSend();
              }}
              disabled={agentTyping}
              ref={inputRef}
            />
            <Button
              icon="pi pi-send"
              onClick={handleSend}
              disabled={agentTyping || !input.trim()}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default CharlyChatWindow;
